module.exports = __webpack_public_path__ + "static/media/pic3.ca33f5dd.webp";